import { pixelsToRem } from 'MoshtixShared/helper-pixels-to-rem';
import { configuration } from 'MoshtixShared/helper-responsive-configuration';

import { ThemeInterface } from 'Types/theme';

const mediumQuery = configuration.getMediaQuery('medium');

const backgroundCss = ({ theme }: { theme: ThemeInterface }) => ({
  backgroundColor: theme.palette.white,
  minHeight: pixelsToRem(450),
  position: 'relative',
  paddingTop: 0,

  [mediumQuery]: {
    paddingTop: 0,
    '&::before': {
      right: 0,
      top: 150,
    },
    '&::after': {
      left: 0,
      top: -180,
    },
  },
});

const eventDetailsCss = {
  marginLeft: pixelsToRem(16),
  marginBottom: pixelsToRem(28),
  flex: 1,
};

const eventDetailsContainerCss = {
  display: 'flex',
  [mediumQuery]: {
    width: 260,
  },
};

const eventDetailsWrapperCss = {
  display: 'flex',
  flexDirection: 'column',
  marginTop: pixelsToRem(40),
  [mediumQuery]: {
    flexDirection: 'row',
  },
};

const flexContainerCss = {
  display: 'flex',
  flexDirection: 'row',
  marginTop: pixelsToRem(30),
  alignItems: 'center',
  [mediumQuery]: {
    flexDirection: 'row',
  },
};

const ticketListWrapperCss = {
  paddingTop: pixelsToRem(50),
  paddingBottom: pixelsToRem(50),
};

const marginLeftPx = (value: number) => ({
  marginLeft: pixelsToRem(value),
});

export default {
  backgroundCss,
  eventDetailsCss,
  eventDetailsContainerCss,
  flexContainerCss,
  eventDetailsWrapperCss,
  ticketListWrapperCss,
  marginLeftPx,
};
